<div class="vehicle-one-paragraph">
    <div class="title-and-line">
        <slot name="title"></slot>
        <div class="line"></div>
    </div>
    <slot name="content"></slot>
</div>

<style>
    .vehicle-one-paragraph {
        display: flex;
        flex-direction: row;
        padding: 13px 40px 13px 40px;
        column-gap: 10px;
    }
    .vehicle-one-paragraph .title-and-line {
        display: flex;
        flex-direction: row;
        /*flex: 0.2 10 160px;*/
        flex: 0 0 140px;
        align-items: center;
        font-weight: 500;
        /*height: 17px;*/
        height: 30px;
    }
    .vehicle-one-paragraph :global([slot="content"]) {
        display: flex;
        flex-direction: row;
        flex: 10 1 auto;
        flex-wrap: wrap;
        row-gap: 10px;
        column-gap: 25px;
    }
    .line {
        box-sizing: border-box;
        border-bottom: 1px solid #000;
        width: 100%;
        padding: 0 20px;
        margin: 0 10px;
    }
</style>

